var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Card, Link, SkeletonLine, Tooltip, Typography, } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { useEffect, useState } from 'react';
import { getTotalSpend } from '../../api/oms/order-history';
import { usePurchaseHistoryContext } from '../../hooks/useContexts';
export var SpendOverview = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var svocID = useThdCustomer().svocID;
    var _p = usePurchaseHistoryContext(), orderHistoryData = _p.orderHistoryData, initResultsFilter = _p.initResultsFilter, orderHistoryLoaded = _p.orderHistoryLoaded, customerType = _p.customerType;
    var _q = useState(null), totalData = _q[0], setTotalData = _q[1];
    var _r = useState(true), loading = _r[0], setLoading = _r[1];
    var totalSpendData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, response;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, , 2, 3]);
                    request = {
                        customerSpendRequest: {
                            customerAccountId: (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.customerAccountId) || svocID || '',
                            groupType: 'YEAR',
                            resultsFilter: initResultsFilter,
                        },
                    };
                    return [4 /*yield*/, getTotalSpend(request)];
                case 1:
                    response = _c.sent();
                    if (response.status === 200) {
                        setTotalData((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.customerSpendByYear) === null || _b === void 0 ? void 0 : _b[0]);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        totalSpendData();
    }, []);
    if (orderHistoryLoaded &&
        customerType === 'b2b' &&
        (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.customerAccountId)) {
        var grossSales_1 = (_d = (_c = (_b = Number((_a = totalData === null || totalData === void 0 ? void 0 : totalData.grossSales) !== null && _a !== void 0 ? _a : 0)) === null || _b === void 0 ? void 0 : _b.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })) === null || _c === void 0 ? void 0 : _c.split('.')) === null || _d === void 0 ? void 0 : _d[0];
        var proxtraSpend_1 = (_h = (_g = (_f = ((_e = totalData === null || totalData === void 0 ? void 0 : totalData.proxtraSpend) !== null && _e !== void 0 ? _e : 0)) === null || _f === void 0 ? void 0 : _f.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })) === null || _g === void 0 ? void 0 : _g.split('.')) === null || _h === void 0 ? void 0 : _h[0];
        var savings_1 = (_m = (_l = (_k = Math.abs((_j = totalData === null || totalData === void 0 ? void 0 : totalData.savings) !== null && _j !== void 0 ? _j : 0)) === null || _k === void 0 ? void 0 : _k.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })) === null || _l === void 0 ? void 0 : _l.split('.')) === null || _m === void 0 ? void 0 : _m[0];
        return (React.createElement(Card, { "data-testid": "spendOverview", className: "sui-w-1/2" },
            React.createElement("div", { className: "sui-flex sui-justify-between" },
                loading ? (React.createElement("div", { className: "sui-w-6/12" },
                    React.createElement(SkeletonLine, { variant: "heading", fullWidth: true }))) : (React.createElement(Typography, { weight: "bold", variant: "h5" }, (_o = totalData === null || totalData === void 0 ? void 0 : totalData.year) !== null && _o !== void 0 ? _o : '',
                    " Spend Overview")),
                React.createElement("div", { className: "sui-flex sui-gap-[8px] sui-items-center" },
                    React.createElement("img", { width: 24, height: 24, alt: "Pro Extra Spend Ribbon", src: "https://assets.thdstatic.com/images/v1/loyalty-badge.svg" }),
                    React.createElement(Link, { href: "https://www.homedepot.com/myaccount/proXtraRewards", variant: "body-base" }, "Rewards History"))),
            React.createElement("div", { className: "sui-flex sui-justify-between" },
                React.createElement("div", null,
                    (function () {
                        if (loading)
                            return React.createElement(SkeletonLine, { variant: "heading" });
                        return (React.createElement(Typography, { variant: "h5", style: { fontSize: '20px' } },
                            "$",
                            grossSales_1));
                    })(),
                    React.createElement(Typography, { variant: "body-base" }, "Total Spend")),
                React.createElement("div", null,
                    (function () {
                        var _a, _b;
                        if (loading)
                            return React.createElement(SkeletonLine, { variant: "heading" });
                        if ((grossSales_1 === null || grossSales_1 === void 0 ? void 0 : grossSales_1.length) > 12 && ((_a = proxtraSpend_1 === null || proxtraSpend_1 === void 0 ? void 0 : proxtraSpend_1.length) !== null && _a !== void 0 ? _a : 0) > 7) {
                            var modifiedProxtraSpend = "".concat(proxtraSpend_1 === null || proxtraSpend_1 === void 0 ? void 0 : proxtraSpend_1.split(',')[0], ".").concat((_b = proxtraSpend_1 === null || proxtraSpend_1 === void 0 ? void 0 : proxtraSpend_1.split(',')[1]) === null || _b === void 0 ? void 0 : _b.slice(0, 1), "K");
                            return (React.createElement(Tooltip, { placement: "bottom", title: "$".concat(proxtraSpend_1) },
                                React.createElement(Typography, { variant: "h5", style: { fontSize: '20px' }, decoration: "underline" },
                                    "$",
                                    modifiedProxtraSpend)));
                        }
                        return (React.createElement(Typography, { variant: "h5", style: { fontSize: '20px' } },
                            "$",
                            proxtraSpend_1));
                    })(),
                    React.createElement(Typography, { variant: "body-base" }, "ProXtra Loyalty Spend")),
                React.createElement("div", null,
                    (function () {
                        var _a;
                        if (loading)
                            return React.createElement(SkeletonLine, { variant: "heading" });
                        if ((grossSales_1 === null || grossSales_1 === void 0 ? void 0 : grossSales_1.length) > 12 && (savings_1 === null || savings_1 === void 0 ? void 0 : savings_1.length) > 7) {
                            var modifiedSavings = "".concat(savings_1 === null || savings_1 === void 0 ? void 0 : savings_1.split(',')[0], ".").concat((_a = savings_1 === null || savings_1 === void 0 ? void 0 : savings_1.split(',')[1]) === null || _a === void 0 ? void 0 : _a.slice(0, 1), "K");
                            return (React.createElement(Tooltip, { placement: "bottom", title: "$".concat(savings_1) },
                                React.createElement(Typography, { variant: "h5", color: "success", style: { fontSize: '20px' }, decoration: "underline" },
                                    "$",
                                    modifiedSavings)));
                        }
                        return (React.createElement(Typography, { variant: "h5", color: "success", style: { fontSize: '20px' } },
                            "$",
                            savings_1));
                    })(),
                    React.createElement(Typography, { variant: "body-base" }, "Total Savings")))));
    }
    return null;
};
